import { useQuery } from "react-query";
import { getEmployeeTitle }  from "../../../../../actions/Utilities/EmployeeTitle";

export default function useGetEmployeeTitle () {
  return useQuery("GetEmployeeTitle",getEmployeeTitle, {
    refetchOnWindowFocus: false,
  });
}
